module.exports = __webpack_public_path__ + "img/Chevron-Up_16px_Icon-Light.c252d9e8.svg";